import ApiUtils from "../ApiUtils";

export default class ApiCalendarViewService {

    async getAllCalendarData(year, month){
        return await ApiUtils.callApi(`calendar/view/${year}/${month}`, 'get');
    }

    async saveCalendarEvent(data) {
        return await ApiUtils.callApi(`calendar/save`, 'post', data);
    }

    async updateCalendarEvent(data) {
        return await ApiUtils.callApi(`calendar/update`, 'post', data);
    }
}

